import React, { useRef, useEffect } from "react";
import './Modal.css';
import { ReactComponent as Close } from '../../svg/close.svg';
const ip = process.env.REACT_APP_IP;

function ModalEnergy({ isOpen, setOpen, type, energies, updateEnergy, handleChange }) {

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

      const iconNRJ = (type,value, max) =>{
        if(type === "Energie"){
            if(value <= max/3){
                return "NRJ3"
              } else if(value <= (max/3)*2){
                return "NRJ2"
              } else {
                return "NRJ1"
              }
        } else if(type === "Vie"){
            if(value <= max/4){
                return "VIE4"
              } else if(value <= max/2){
                return "VIE3"
              } else if(value <= (max/4)*3){
                return "VIE2"
              } else {
                return "VIE1"
              }
        }



      }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    const handleIncrement = (variable) => updateEnergy(type, variable, true);
    const handleDecrement = (variable) => updateEnergy(type, variable, false);

    if (!isOpen) return null;
    return (
        <div className="modal-overlay">
            <div ref={wrapperRef} className="modal_flex width-65vw">
            <div className="close" onClick={() => setOpen(false)}><Close /></div>
                {Object.entries(energies[type] || {}).map(([variable, item]) => (
                    <div key={variable} className="place-centre margin_1em">
                        <span className={""}>{item.nom}</span>
                        <div  className="adjustable-control ">
                            
                            <button className={"button increment left-2em " + "" } onClick={() => handleDecrement(variable)}>
                            <div className="symbole right-50">
                                    -
                                </div>
                                <div
                                className={"progress-bar-fill-right " + type}
                                style={{
                                    width: `${(item.valeur / item.maximum) * 100}%`
                                }}
                            ></div>

                            </button>
                            <div className="trapezoid stack-base">
                            </div>

                            <img className='vitality_icon stack-1' src={`${process.env.PUBLIC_URL}/Images/${iconNRJ(type,item.valeur,item.maximum)}.ico`} alt="icon" />
                            <input
                                    type="number"
                                    className={"value stack-2 " + (type == "Energie" ? "number-nrj" : "number-vie")}
                                    value={item.valeur || 0}
                                    onChange={e => handleChange(e, type, variable,item.maximum)}
                                    onFocus={e => e.target.select()}
                                />
                            <button className={"button decrement  right-2em "+ "" } onClick={() => handleIncrement(variable)}>
                                <div className="symbole left-50">
                                    +
                                </div>
                                <div
                                className={"progress-bar-fill " + type}
                                style={{
                                    width: `${(item.valeur / item.maximum) * 100}%`
                                }}
                            ></div>
                            </button>
                        </div>

                    </div>
                ))}
            </div>
        </div>
    );
}

export default ModalEnergy;
